import { useDemoOrg } from '@/contexts/DemoOrgContext';
import { useOrg } from '@/contexts/OrgContext';
import { useIsDemo } from '@/hooks/common/useIsDemo';
import { PERSONAL_ORG_ID } from '@/mockData/common/demoFilters';

export function useSelectedOrgId(): string {
  const demoOrg = useDemoOrg();
  const { selectedOrgId } = useOrg();
  const isDemo = useIsDemo();

  if (demoOrg) {
    if (demoOrg.isPersonalMode) {
      return PERSONAL_ORG_ID;
    }

    return demoOrg.selectedOrg?.orgId ?? PERSONAL_ORG_ID;
  }

  if (isDemo) {
    return selectedOrgId || PERSONAL_ORG_ID;
  }

  return selectedOrgId ?? '';
}
